export const _getSimpleDate = (date) => {
  const arr = date.split('T')
  const result = arr[0].split('-').join('.')
  return result
}

export const _makeCapitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}